import {
  SET_FILTERS,
  SET_PAGINATION_DATA,
  SET_SEARCH_TERM,
  RESET_PAGINATION,
} from './ui.actions.types';

const pagination = {
  descending: false,
  page: 1,
  rowsPerPage: 10,
  totalItems: 0,
  sort: 'name',
};

const state = {
  filters: {
    access: 'all',
    language: 'all',
    resourceType: 'all',
    translation: 'all',
  },
  pagination,
  search: '',
};

const getters = {
  filters(state) {
    return state.filters;
  },
  pagination(state) {
    return state.pagination;
  },
  search(state) {
    return state.search;
  },
};

const actions = {
  async [SET_FILTERS](context, filters) {
    context.commit(SET_FILTERS, filters);
  },
  async [SET_PAGINATION_DATA](context, paginationData) {
    context.commit(SET_PAGINATION_DATA, paginationData);
  },
  async [RESET_PAGINATION](context) {
    context.commit(SET_PAGINATION_DATA, pagination);
  },
  [SET_SEARCH_TERM](context, searchTerm) {
    context.commit(SET_SEARCH_TERM, searchTerm);
  },
};

const mutations = {
  [SET_FILTERS](state, filters) {
    state.filters = filters;
  },
  [SET_PAGINATION_DATA](state, paginationData) {
    state.pagination = paginationData;
  },
  [SET_SEARCH_TERM](state, searchTerm) {
    state.search = searchTerm;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
